<template>
  <v-container fluid class="mainTextBlock">
    <v-row justify="start" class="pageRow">
      <input-block
        :modules="location"
        title="Наше месторасположение:"
        :options="{ tabs: true }"
      />
      <v-card class="mb-2" id="mainStats">
        <v-card-title>Статистика</v-card-title>
        <v-tabs v-model="statsTab" vertical>
          <v-tab
            v-for="stat in stats"
            :key="stat.field"
            v-html="stat.subheader"
          />
          <v-tab-item v-for="stat in stats" :key="stat.field" eager>
            <input-block
              :ref="stat.field"
              :modules="statsModules[stat.field]"
              :options="{ flat: true, title: false }"
              @saved="statSaved"
            />
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import InputBlock from "../InputBlock/InputBlock";

export default {
  name: "MainTextBlock",
  components: { InputBlock },
  data() {
    return {
      statsTab: null,
      location: {
        main: {
          map: {
            type: "image",
            langs: ["all"],
            label: "Карта",
            hint: "605x363"
          },
          production: {
            type: "string",
            langs: ["ru", "kk", "en"],
            label: "Производство"
          },
          office1: {
            type: "string",
            langs: ["ru", "kk", "en"],
            label: "Офис 1"
          },
          office2: {
            type: "string",
            langs: ["ru", "kk", "en"],
            label: "Офис 2"
          },
          office3: {
            type: "string",
            langs: ["ru", "kk", "en"],
            label: "Офис 3"
          }
        }
      },
      stats: [
        {
          subheader: "добыча руды в год",
          field: "year_production"
        },
        {
          subheader: "катодной меди в год",
          field: "copper_production"
        },
        {
          subheader: "срок разработки месторождения",
          field: "age"
        },
        {
          subheader: "квалифици&shy;рованных сотрудников",
          field: "team"
        }
      ],
      statsSaving: false,
      statsSaved: 0
    };
  },
  computed: {
    statsModules() {
      const result = {};
      this.stats.forEach((stat) => {
        result[stat.field] = { main: {} };
        result[stat.field].main[stat.field] = {
          type: "string",
          langs: ["all"],
          label: "значение"
        };
        result[stat.field].main[stat.field + "_measure"] = {
          type: "string",
          langs: ["ru", "kk", "en"],
          label: "Единицы измерения"
        };
      });
      return result;
    }
  },
  methods: {
    statSaved() {
      if (this.statsSaving) {
        this.statsSaved++;
        if (this.statsSaved === this.stats.length - 1) {
          this.statsSaving = false;
        }
      } else {
        this.statsSaving = true;
        this.statsSaved = 0;
        this.stats.forEach((stat) => {
          this.$refs[stat.field][0].save();
        });
      }
    }
  }
};
</script>
<style lang="scss">
.mainTextBlock {
  .pageRow > .v-card {
    margin: 12px;
    min-width: 400px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    &.disclaimerCard {
      min-width: 500px;
      flex-grow: 2;
    }

    > .v-card__text {
      flex-grow: 1;
    }

    > .v-card__actions {
      flex-direction: column;
      align-items: flex-end;
    }
  }
  #mainStats {
    .v-tabs-bar {
      max-width: 200px;
      .v-tab {
        white-space: normal;
        text-align: left;
        margin-bottom: 8px;
      }
    }
    .v-slide-group__content {
      width: 100%;
    }
    .v-window {
      flex-grow: 1;
    }
    .v-window__container,
    .v-window-item,
    .textCard {
      height: 100%;
    }
    .textCard {
      display: flex;
      flex-direction: column;
      .v-card__text {
        flex-grow: 1;
        padding-top: 0;
      }
    }
  }
}
</style>
